import { FeeItem } from "@/app/nft/price-quote/price-quote"
import { PriceInCrypto } from "@/app/price"
import type { PriceValue } from "@anaconda/core/price/types"
import { Trans } from "@lingui/react/macro"
import { Card } from "@rarible_int/anaconda_ui_components"
import Big from "big.js"

interface Props {
  price: PriceValue
  quantity: number
  fee?: number
}

export function PriceQuote({ price, quantity, fee }: Props) {
  const baseAmount = (() => {
    try {
      return Big(price.amount)
    } catch {
      return Big(0)
    }
  })()
  const safeFee = Number.isFinite(fee ?? 0) ? (fee ?? 0) : 0

  return (
    <Card className="flex flex-col gap-2 p-4">
      {fee ? (
        <div className="flex flex-col gap-1 border-b pb-2 text-2xs">
          <FeeItem fee={fee} price={price} label={<Trans>Service fee</Trans>} />
        </div>
      ) : null}

      <QuoteItem
        name={<Trans>You will pay</Trans>}
        value={
          <PriceInCrypto
            amount={baseAmount.plus(safeFee).mul(quantity).toString()}
            currency={price.currency}
          />
        }
      />
    </Card>
  )
}

function QuoteItem({
  name,
  value,
}: { name: React.ReactNode; value: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-foreground/60">{name}</span>
      {value}
    </div>
  )
}
